import React from 'react';
import { datePropTypes } from './DatePropTypes';
import * as styles from './Date.module.scss';
const Date = ({
  updatedAt,
  classname
}) => {
  if (!updatedAt) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || ''}`
  }, updatedAt.label, /*#__PURE__*/React.createElement("time", {
    className: styles.rootDate,
    dateTime: updatedAt.date.iso
  }, updatedAt.date.string));
};
export default Date;